import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Checkbox as FluentCheckbox } from 'office-ui-fabric-react/lib/Checkbox';

const Checkbox = ({
  field: { name, value },
  form: { errors = {}, isSubmitting = false, setFieldValue, setFieldTouched },
  label,
  disabled,
  required,
  callout,
  className,
  ...other
}) => (
  <FluentCheckbox
    label={label}
    checked={value}
    onChange={val => {
      setFieldValue(name, val.target.checked);
      setFieldTouched(name);
    }}
    disabled={disabled || isSubmitting}
    errorMessage={get(errors, name)}
    className={className}
    ariaLabel={label}
    {...other}
  />
);

Checkbox.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    isSubmitting: PropTypes.bool,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
  }),
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  callout: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

Checkbox.defaultProps = {
  className: '',
  callout: null,
  disabled: false,
  required: false,
  form: {
    touched: {},
    errors: {},
    isSubmitting: false,
    setFieldValue: () => {},
    setFieldTouched: () => {},
  },
};

export default Checkbox;
